import { createSelector } from 'reselect'

export const getLocale = state => state.locale
export const getLocales = state => state.locales

export const getText = createSelector([getLocale, getLocales], (locale, locales) => {
    let result
    try {
        result = locales[locale]
    } catch (error) {
        console.info(`Encountered error while getting localized text: ${error.message}`)
    }

    if (result == null) {
        // return empty result
        return {}
    }

    return result
})

export const getLocalizedText = createSelector([getText], text => ({
    launcherText: text.launcher,
    versionText: text.version,
    patchNotes: text.patchNotes,
}))



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/localized/selectors.js